module.exports = __webpack_public_path__ + "media/ko.40f91945.mp3";